import React from 'react'

import '@Ui/css/mobile-media-viewer.css'
import useMediaViewer from '@Hooks/mediaViewer/useMediaViewer'

const MediaViewerComponent: React.FC = () => {
  useMediaViewer()
  return <></>
}

export default MediaViewerComponent
